module.exports = __webpack_public_path__ + "img/feather-white.4700208a.svg";